import "./index.scss";
import React from "react";
import SelectOptions from "./SelectOptions/SelectOptions";

class SelectMultipleContainer extends React.Component {
    constructor(props) {
        super(props);
    }
   
    render() {
        return <SelectOptions {...this.props} />;
    }
}

export default SelectMultipleContainer;